import React from "react";
import ManagerNavbar from "../Layout/ManagerNavbar";
import PlacementAdminPage from "../placement/PlacementAdminPage";

export default function ManagerPlacementPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <ManagerNavbar />
      <PlacementAdminPage />
    </div>
  );
}
